import type { DisplayCue } from "@expert/contentful/src/types";

export const getListeningText = (cues: DisplayCue[], isInsightsEnabled: boolean) => {
    const hasPreviousDetections = cues.some((c) => c.isDetectedOnPreviousCall);
    const hasCurrentDetections = cues.some((c) => c.detected && !c.isDetectedOnPreviousCall);

    let listeningText = "Listening for devices";
    if (isInsightsEnabled) {
        listeningText = "Listening for tech and insights";
    } else if (hasPreviousDetections && hasCurrentDetections) {
        listeningText = "Detected from previous and current call";
    } else if (hasCurrentDetections) {
        listeningText = "Detected from current call";
    } else if (hasPreviousDetections) {
        listeningText = "Detected from previous call";
    }

    return listeningText;
};
